export default {
  appTitle: 'Autorizaciones',
  filters: {
    searchCode: 'Buscar por ID',
    coverage: 'Cobertura',
    status: 'Estado',
    date: 'Rango de fechas'
  },
  dataTableHeaders: {
    id: 'ID Autorización',
    createdAt: 'Fecha de creación',
    sponsorName: 'Aseguradora',
    beneficiaryName: 'Asegurado/a',
    beneficiaryMemberCode: 'Identificación de póliza',
    identification: 'Identificación',
    coverageType: 'Tipo de autorización',
    status: 'Estado'
  },
  resultLabel: {
    text: `Resultados`,
    result: `({result})`
  },
  status: {
    ready: 'Validación pendiente',
    rejected: 'Rechazada',
    qualification: 'Ingreso hospitalario',
    pendingReview: 'En dictamen',
    approved: 'Dictaminada',
    claimed: 'Facturada',
    completed: 'Completada',
    voided: 'Anulada',
    notAttended: 'No asistió',
    sentToSponsor: 'Envío aseguradora',
    paymentConfirmed: 'Pago confirmado',
    paid: 'Pagada'
  },
  coverage: {
    hospitalization: 'Hospitalización'
  },
  addAuthorization: {
    title: 'Nueva valoración',
    creating: 'Creando autorización...'
  },
  diagnoses: {
    panelTitle: 'Diagnósticos',
    title: 'Diagnósticos',
    emptyState: 'Aún no se han agregado diagnósticos',
    customDiagnosisItemListLabel: 'Diagnóstico',
    searchLabel: 'Buscar diagnóstico',
    searchCustom: 'Buscar {label}',
    emptyStateCustom: 'No se han agregado {label}',
    emptyList: 'No se encontraron resultados',
    addDiagnosisLabel: "+ Agregar '{value}'",
    maximumNumberOfItemsReached: 'Cantidad máxima alcanzada',
    errors: {
      repeated: 'Ya ha agregado este diagnóstico'
    }
  },
  beneficiaryHeader: {
    name: 'Nombre y apellido',
    identityDocumentId: 'Identificación',
    beneficiaryEmail: 'Email',
    memberCode: 'Nº asegurado'
  },
  medicalProcedure: {
    searchLabel: 'Buscar procedimiento medico',
    emptyState: 'Aún no se han agregado procedimientos medicos'
  },
  buttons: {
    next: 'Continuar',
    end: 'Finalizar',
    cancel: 'Cancelar',
    return: 'Regresar',
    add: 'Agregar',
    exit: 'Salir',
    btnLink: 'Ver documentación'
  },
  statusProductsAuthorizations: {
    approved: 'Aprobado',
    rejected: 'Rechazado',
    manualReviewRequired: 'Requiere revisión manual'
  },
  authorizationProductsDetails: {
    headers: {
      codeDiagnoses: 'Código CIE-10',
      codeProduct: 'CPT',
      name: 'Nombre',
      status: 'Estado'
    },
    emptyList: 'No se encontraron resultados'
  },
  uploadPreInvoiceSuccess: 'El egreso del paciente se ha realizado exitosamente.',
  uploadInvoiceSuccess: 'El envío de la factura se ha realizado exitosamente.',
  authorizationPreInvoiceItems: {
    headers: {
      name: 'Producto',
      discount: 'Descuento',
      quantity: 'Cantidad',
      unitPrice: 'Precio unitario',
      total: 'Total',
      status: 'Estado',
      accountStatement: 'Estado de cuenta',
      approved: 'Productos aprobados',
      rejected: 'Productos rechazados',
      sum: 'Suma',
      totalDiscount: 'Descuentos',
      taxes: 'I.V.A.',
      subtotal: 'Total',
      totalAdvanced: 'Anticipo',
      totalToPay: 'Por pagar',
      searchFilter: 'Buscar por producto y estado'
    }
  }
}
